import React from 'react'
import { BlockMain } from '@blocks/BlockMain'
import { MainBlock } from '@blocks/BlockMain/model'
import { ApplicationForms } from '@shared/components/forms/application'
import { scrollToApplicationForm } from '@shared/components/forms/application/cross'
import PageAnimation from '@shared/components/page-animation'
import { Section } from '@shared/components/section'
import { AppSection } from '@shared/components/sections/app'
import { Journal } from '@shared/components/sections/journal'
import { Rate } from '@shared/components/sections/rate'
import { RiskPoints } from '@shared/components/sections/riskPoints'
import { StepsNoSection } from '@shared/components/sections/steps'
import { YouTube } from '@shared/components/sections/youtube'
import { mainBlock } from 'data/mfo-refinance'

import { stepsData } from './sections/steps/data'

import styles from './style.module.scss'

interface Props {
	mainBlockPath?: Partial<MainBlock>
	ratePoints?: string[]
	minLoan?: number
}

export const View = ({ mainBlockPath, ratePoints, minLoan }: Props) => (
	<PageAnimation>
		<BlockMain
			adornmentClassname={styles.mainAdornment}
			imageAdornmentWrapClassName={styles.imageAdornment}
			data={{ ...mainBlock, ...mainBlockPath }}
			buttonProps={{
				onClick: scrollToApplicationForm,
			}}
		/>
		<Section className={styles.appWrap} fullWidth>
			<Rate points={ratePoints} buttonText='Получить рефинансирование' />
			<AppSection />
		</Section>
		<Section className={styles.stepsWrap} fullWidth>
			<h2 className={styles.sectionTitle}>3 простых шага для получения кредита</h2>
			<StepsNoSection stepTextStyles={styles.extraTextStyles} steps={stepsData} />
			<h2 className={styles.sectionTitle}>Вы не рискуете</h2>
			<RiskPoints />
		</Section>
		<Section className={styles.youtubeWrap} fullWidth>
			<Journal />
			<YouTube />
		</Section>
		<ApplicationForms.Cross
			processBarText='Вероятность одобрения займа'
			formTitle='Заявка на рефинансирование'
			formDescription='Объедините все кредиты и снизьте платёж'
			// isRefinance
			minLoan={minLoan}
		/>
	</PageAnimation>
)
